import type { NavImpactSurfaces } from '../arms';

export const spec = (): Partial<NavImpactSurfaces> => ({
  barStyle: 'whole_bar',
  statStyle: 'trend_icon',
  statLayout: 'inline',
});
